import {useBrand} from '../contexts/brand-context'

const BRAND_PAGE_PREFIXES = {
    garage: 'gar',
    dynamite: 'dyn'
}

export const useLegalPagePaths = () => {
    const {brandId} = useBrand()
    const prefix = BRAND_PAGE_PREFIXES[brandId] || BRAND_PAGE_PREFIXES.garage

    return {
        privacyPolicyPath: `/${prefix}-privacy-policy.html`,
        termsAndConditionsPath: `/${prefix}-terms-condition.html`
    }
}

export default useLegalPagePaths
